<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Sofa`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2C6.34315 2 5 3.34315 5 5V9H3C1.89543 9 1 9.89543 1 11V18C1 19.1046 1.89543 20 3 20C3 21.1045 3.89543 22 5 22C6.10455 22 7 21.1045 7 20L17 20C17 21.1046 17.8955 22 19 22C20.1045 22 21 21.1046 21 20C22.1046 20 23 19.1046 23 18V11C23 9.89543 22.1046 9 21 9H19V5C19 3.34315 17.6569 2 16 2H8ZM7 20H3L3.53458 20.0002H3.53484C4.53929 20.0007 6.56652 20.0017 7 20ZM7 5C7 4.44772 7.44772 4 8 4H16C16.5523 4 17 4.44772 17 5V15H7V5Z"/></svg>
</template>
<script>

export default {
  name: 'IconSofa',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
